"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropListItemScroller = void 0;
var React = require("react");
var keyboard = require("../../_Core/Keyboard");
var DropList_styles_1 = require("./DropList.styles");
var DropListItemScroller = function (_a) {
    var children = _a.children, MaxHeight = _a.MaxHeight, NoItemsMessage = _a.NoItemsMessage, OnCloseMenu = _a.OnCloseMenu, Style = _a.Style, SetReplacer = _a.SetReplacer;
    var ulRef = React.createRef();
    var handleOnKeyPressed = function (e) {
        e.stopPropagation();
        var target = e.target;
        if ((target.type !== "search" && keyboard.IsSpace(e))
            || keyboard.IsEnter(e)) {
            target.click();
        }
        else if (keyboard.IsDownArrow(e)) {
            moveToNextSibling(target);
        }
        else if (keyboard.IsUpArrow(e)) {
            moveToPrevSibling(target);
        }
        else if (keyboard.IsEscape(e) && OnCloseMenu) {
            OnCloseMenu();
        }
        else if (keyboard.IsLeftArrow(e) && OnCloseMenu) {
            OnCloseMenu();
        }
        else if (keyboard.IsRightArrow(e)) {
            if (target.attributes.getNamedItem("aria-haspopup") !== null &&
                target.attributes.getNamedItem("aria-haspopup").value === "true") {
                target.click();
            }
        }
    };
    var moveToPrevSibling = function (target) {
        var newTarget = target.parentElement.previousSibling;
        if (newTarget) {
            var child = newTarget.firstChild;
            if (child.nodeName === "HR" || child.disabled) {
                moveToPrevSibling(child);
            }
            else {
                var setFocus = newTarget.firstChild;
                if (setFocus) {
                    setFocus.focus();
                }
            }
        }
    };
    var moveToNextSibling = function (target) {
        var newTarget = target.parentElement.nextSibling;
        if (newTarget) {
            var child = newTarget.firstChild;
            if (child.nodeName === "HR" || child.disabled) {
                moveToNextSibling(child);
            }
            else {
                var setFocus = newTarget.firstChild;
                if (setFocus) {
                    setFocus.focus();
                }
            }
        }
    };
    return (React.Children.count(children) > 0 ?
        React.createElement(DropList_styles_1.UL, { MaxHeight: MaxHeight, onKeyDown: handleOnKeyPressed, ref: ulRef, role: "menu" }, React.Children.map(children, function (child) { return React.cloneElement(child, {
            OnCloseMenu: OnCloseMenu,
            SetReplacer: SetReplacer,
            Style: Style,
        }); }))
        :
            React.createElement(React.Fragment, null, NoItemsMessage && React.createElement(DropList_styles_1.NoItemsP, null, NoItemsMessage)));
};
exports.DropListItemScroller = DropListItemScroller;
